import vue from 'vue'

import  Vuex from 'vuex'

vue.use(Vuex)


const state={   //要设置的全局访问的state对象
    
    tabCur: 0,
    winHeight:''
    //要设置的初始属性值
  };
const getters = {   //实时监听state值的变化(最新状态)
  
   getTabCur(state){
    return state.tabCur
   }
};
const mutations = {
   
    newTabCur(state,sum){ //同上，这里面的参数除了state之外还传了需要增加的值sum
       state.tabCur  = sum;
    }
};
const actions = {
  
    getNewTabCur(context,num){   //同上注释，num为要变化的形参
        context.commit('newTabCur',num)
     }
};
 const store = new Vuex.Store({
       state,
       getters,
       mutations,
       actions
});
export default store;




// WEBPACK FOOTER //
// ./src/store.js